import * as React from 'react';
import { __ } from 'react-i18n';
import { FlexCol } from '../../Defaults/Flexbox/Flexbox';
import styled from 'styled-components';
import { rem } from 'polished';
import { TitleWithChildren } from '../General/TitleWithChildren';
import { ContactInfo } from './Form/ContactInfo';
import { BillingAddress } from './Form/BillingAddress';
import { DeliveryAddress } from './Form/DeliveryAddress';
import { FormTextArea } from '../Form/FormTextArea';
import OptionChooser from './OptionChooser/OptionChooser';
import { BlockWithTitle } from '../General/BlockWithTitle';
import { Select } from '../General/Select';
import { TextP } from '../../Defaults/Text';
import { ZemplinLoaderWrapper } from '../../..';
import { remapDeliveryItem, remapPaymentItem } from './utilities';
import { prop, arrayToObject } from '../../../utilities';
import { InfoText, InfoType } from '../General/InfoText';

interface Props {
  data: any;
  isFetching: boolean;
  isFetchingDelAndPayInfo: boolean;
  updateCart: any;
  delAndPayInfoIds: string[];
  delAndPayInfoById: any;
  user: any;
  showProblems: boolean;
  openZasielkovnaWidget: () => void;
}

function CartDeliveryPart({
  data,
  isFetching,
  delAndPayInfoIds,
  delAndPayInfoById,
  isFetchingDelAndPayInfo,
  updateCart,
  user,
  showProblems,
  openZasielkovnaWidget,
}: Props) {
  const deliveryId = prop(data, 'delivery.id');
  const paymentId = prop(data, 'payment.id');

  if (isFetchingDelAndPayInfo) {
    return <ZemplinLoaderWrapper />;
  }
  if (!delAndPayInfoById) {
    return null;
  }

  const delAndPayInfoByIdCopy = { ...delAndPayInfoById };
  const disablePickupBoxes = prop(data, 'disable_pickup_boxes', false);
  if (data && disablePickupBoxes === true) {
    Object.keys(delAndPayInfoByIdCopy).forEach(key => {
      if (delAndPayInfoByIdCopy[key].delivery_id === 'ZASIELKOVNA') {
        delete delAndPayInfoByIdCopy[key];
      }
    });
  }

  const deliveryItems = Object.keys(delAndPayInfoByIdCopy).map(key =>
    remapDeliveryItem(delAndPayInfoByIdCopy[key]),
  );

  const currentDeliveryOption = delAndPayInfoByIdCopy[deliveryId];

  const isLoggedIn = user ? true : false;
  const paymentsFilterLoggedIn = ['PREVODOM'];
  const paymentsFIltered =
    currentDeliveryOption && currentDeliveryOption.payments
      ? isLoggedIn
        ? currentDeliveryOption.payments.filter(
            payment => !paymentsFilterLoggedIn.includes(payment.payment_id),
          )
        : currentDeliveryOption.payments
      : [];

  const paymentsById = paymentsFIltered
    ? arrayToObject(paymentsFIltered, 'payment_id')
    : [];

  const paymentItems =
    paymentsFIltered &&
    paymentsFIltered.map(payment => remapPaymentItem(payment));

  const selectedDelivery = deliveryId
    ? remapDeliveryItem(delAndPayInfoByIdCopy[deliveryId])
    : null;
  const selectedPayment = paymentId
    ? remapPaymentItem(paymentsById[paymentId])
    : null;

  const cartProblems = prop(data, 'problems', []);

  const onChangeDelivery = id => {
    if (id === 'ZASIELKOVNA') {
      openZasielkovnaWidget();
    } else {
      const del = delAndPayInfoByIdCopy[id];
      if (del) {
        const payment = del.payments.find(p => p.payment_id === paymentId);
        if (!payment) {
          updateCart({ ...data, delivery: { id }, payment: null });
        } else {
          updateCart({ ...data, delivery: { id } });
        }
      }
    }
  };

  const onChangePayment = id => {
    updateCart({ ...data, payment: { id } });
  };

  return (
    <Wrapper>
      {showProblems && cartProblems && cartProblems.length > 0 ? (
        <>
          {cartProblems.map((problem, i) => (
            <>
              {i === 0 ? (
                <InfoText
                  key={problem.readable}
                  maxWidth={1168}
                  type={InfoType.ERROR}
                  info={problem.readable}
                />
              ) : null}
            </>
          ))}
        </>
      ) : null}

      <TitleWithChildren title={__('Spôsob dopravy')}>
        <OptionChooser
          zasielkovnaPayload={prop(data, 'zasielkovna_payload')}
          items={deliveryItems}
          selectedOption={selectedDelivery}
          handleOptionClick={onChangeDelivery}
        />
      </TitleWithChildren>
      <TitleWithChildren title={__('Spôsob platby')}>
        {paymentItems && paymentItems.length > 0 ? (
          <OptionChooser
            items={paymentItems}
            selectedOption={selectedPayment}
            handleOptionClick={onChangePayment}
          />
        ) : (
          <InfoText
            type={InfoType.INFO}
            info={__('Zvoľte prosím preferovaný spôsob dopravy')}
            noIcon={true}
          />
        )}
      </TitleWithChildren>
    </Wrapper>
  );
}

const Wrapper = styled(FlexCol)`
  max-width: ${rem(700)};
  width: 100%;
`;

const Text = styled(TextP)`
  margin-bottom: ${rem(24)};
  font-size: ${rem(14)};
`;

const DeliveryInfoWrapper = styled(FlexCol)`
  padding: ${rem(32)};
`;

export { CartDeliveryPart };
